export const ROLES = {
  ADMIN: 'admin',
  SENIOR_ACCOUNTANT: 'senior_accountant',
  ORDER_PROCESSOR: 'order_processor',
  DELIVERY_COORDINATOR: 'delivery_coordinator',
};

const PAGE_ACCESS = {
  '/dashboard':   ['admin', 'senior_accountant'],
  '/finance':     ['admin', 'senior_accountant'],
  '/inventory':   ['admin', 'senior_accountant', 'order_processor'],
  '/invoicing':   ['admin', 'senior_accountant', 'delivery_coordinator'],
  '/hrm':         ['admin', 'senior_accountant'],
  '/outsourcing': ['admin', 'senior_accountant'],
  '/reports':     ['admin', 'senior_accountant'],
  '/settings':    ['admin'],
};

export const canAccessPage = (role, path) => {
  if (!role || !path) return false;
  const basePath = '/' + path.split('/')[1];
  return PAGE_ACCESS[basePath]?.includes(role) ?? false;
};

export const getDefaultRedirect = (role) => {
  if (role === 'order_processor') return '/inventory';
  if (role === 'delivery_coordinator') return '/invoicing';
  return '/dashboard';
};

export const canDelete = (role) => role === 'admin';
export const canSeePrice = (role) => role !== 'order_processor';
export const canEditOrder = (role) => ['admin', 'senior_accountant'].includes(role);
export const canAccessInvoicesTab = (role) => role !== 'delivery_coordinator';
